import React from 'react';
import getHelpFileURL from '../../utils/getHelpFileURL';
import { BlogSetup } from '../BlogSetup';

export default function BlogContentBlock({ body }) {
  return body ? (
    <div className="blog-post">
      <BlogSetup content={body} />
    </div>
  ) : null;
}
